<template>
    <div class="card card-height">
        <div class="table-container">
            <table class="table create-billing table-width">
                <thead>
                    <tr>
                        <th class=" pl-10 particular">Item Details</th>
                        <th>Service Resource</th>
                        <th>Schedule</th>
                        <th class="qty">Qty</th>
                        <th class="rate">Rate</th>
                        <th class="sub-amount">Amount</th>
                        <th class="discount">Dis(%)</th>
                        <th class="d-amount">Dis</th>
                        <th class="after-amount">After Discount</th>
                        <th class="total">Total Amount</th>
                        <th class="th-action"></th>
                    </tr>
                </thead>

                <tbody ref="tableRef">
                    <RowInline
                        v-for="(item, i) in tableItems" :key="i"
                        :item="item" :index="i"
                        @onOpenEditItem="onOpenEditItem"
                        @onDeleteItem="onDeleteItem"
                        @onOpenDentitionModal="onOpenDentitionModal"
                    />

                </tbody>
            </table>
            <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, inject } from 'vue';
import RowInline from './RowInline.vue';
const emit = defineEmits(['onOpenDentitionModal']);
const tableRef = ref(null)

const props = defineProps({
  tableItems: {
    type: Array,
    default: []
  },
})

const onOpenDentitionModal = (item, index) => {
  emit('onOpenDentitionModal', item, index)
}

const onOpenEditItem = (index) => {
  props.tableItems[index].is_edit = true;
}

const onDeleteItem = (index) => {
    props.tableItems.splice(index, 1);
}

</script>

<style>
.price-adj{
  display: flex;
  align-items: center;
}

.discount-adj{
  width: 60%;
}

.create-billing > :not(first-child) > * {
  padding-left: 10px !important;
}

.table-totals{
  font-weight: bold;
}
.product{
  width: 60%;
}
.comma-sep{
  text-align: right;
}

.create-billing > :not(caption) > * > * {
  padding: 0.72rem 0.2rem;
}
.particular{
  width: 25%;
}
.qty{
  width: 6%;
}
.discount{
  width: 5%;
}


.card-height{
  min-height: 200px
}

.add-new-line {
  margin-top: 4%;
}
</style>